/* eslint-disable */
import { useState } from 'react';
import { isEmpty } from 'lodash';
import useTable from 'src/hooks/useTable';
import { TableHeadCustom } from 'src/components/table';
import ContactAction from './ContactAction';
import { WrappedPatient } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient';
import { TABLE_HEAD_RELATED_PERSON } from 'src/careflow/common/table-head';
import {
  Box,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  Typography,
} from '@mui/material';
import ContactRow from './ContactRow';
import useLocales from 'src/careflow/ph-core/internationalization/hook/useLocales';
import { translateTableHead } from 'src/careflow/helpers/common';
import { checkAclValidation } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import crsAcls from 'src/careflow/ph-core/admin/permissions/util/crs/crsAcls';
import { Add } from '@mui/icons-material';
import { useValueSet } from 'src/careflow/ph-core/fhir-client/fhir-react';
import { ValueSetWrapper } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/ValueSet';

type Props = {
  patient: WrappedPatient | null;
};

export function ContactList({ patient }: Props) {
  const [open, setOpen] = useState(false);
  const [row, setRow] = useState(null);
  const { i18n } = useLocales();

  const { page, rowsPerPage, onChangePage, onChangeRowsPerPage } = useTable({});

  const [relationshipValueSet] = useValueSet('relatedperson-relationshiptype', {
    map: ValueSetWrapper,
  });

  const handleEdit = (row: any) => {
    setOpen(true);
    setRow(row);
  };

  const handlerClose = () => {
    setRow(null);
    setOpen(false);
  };

  return (
    <>
      <Stack sx={{ m: 1 }}>
        <Grid container display={'flex'} alignItems={'center'} paddingRight={2}>
          {checkAclValidation({ acls: [crsAcls.CRS.PATIENT.CONTACTS.ADD] }) && (
            <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
              <Button
                variant="contained"
                size="small"
                sx={{ height: '36px' }}
                startIcon={<Add />}
                style={{ position: 'absolute', top: '25px', right: '25px' }}
                onClick={() => setOpen(true)}
              >
                {i18n('patients.details.contacts.button', 'crs')}
              </Button>
            </Grid>
          )}
        </Grid>
      </Stack>
      <TableContainer>
        <Table size="small" sx={{ mb: 2 }}>
          <TableHeadCustom headLabel={translateTableHead(TABLE_HEAD_RELATED_PERSON, i18n, 'crs')} />
          <TableBody>
            {!isEmpty(patient?.contact) ? (
              patient?.contact
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => <ContactRow row={row} handleEdit={handleEdit} />)
            ) : (
              <TableCell colSpan={TABLE_HEAD_RELATED_PERSON?.length}>
                <Typography variant="body2" align="center">
                  No rows
                </Typography>
              </TableCell>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ position: 'relative' }}>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={patient?.contact ? patient.contact.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
        />
      </Box>
      <ContactAction 
        patient={patient} 
        contact={row} 
        open={open} 
        onClose={handlerClose} 
        relationshipValueSet={relationshipValueSet}
      />
    </>
  );
}
